import React from 'react';
import { useNavigate } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';

// You can import the fonts directly into your CSS or via Google Fonts
import '../App.css'; // Assuming you have a separate CSS file for custom styles

const AboutWhy = () => {
    const navigate = useNavigate();
  
    const handleReadMoreClick = () => {
      navigate('/thermography');
    };
  return (
    <>
      <section className="about-why py-5">
        <div className="container">
          <h1 className="text-center mb-4 montserrat-font">Why Breast Infrared?</h1>
          <div className="why-thermal-line"></div>
          <p className="poppins-font">
            Breast Infrared is a revolutionary, non-invasive screening method that detects early physiological changes in breast tissue using infrared imaging. Unlike mammograms, which rely on X-rays and compression, Breast Infrared is entirely radiation-free, making it a safer alternative for women of all ages. This technology captures heat patterns and vascular activity, helping to identify potential abnormalities long before structural changes appear on traditional scans.
          </p>
          <p className="poppins-font">
            Many women experience discomfort with conventional screening methods, but Breast Infrared offers a pain-free and stress-free experience. It is particularly beneficial for women with dense breast tissue, those seeking an alternative to frequent radiation exposure, and individuals who prefer a proactive approach to breast health. By detecting temperature variations and abnormal heat patterns, it provides valuable insights into early disease markers, helping women take preventive action sooner.
          </p>
          <p className="poppins-font">
            Scientific research and clinical studies support the effectiveness of Breast Infrared as a complementary tool in breast cancer prevention. Medical experts recognize its potential in identifying high-risk cases, especially when used alongside traditional screening methods. With its ability to monitor long-term breast health, Breast Infrared empowers women to make informed decisions and prioritize early detection.
          </p>
          <div className="text-center mt-4">
            <button className="btn gradient-btn" onClick={handleReadMoreClick}>
              Read More ➜
            </button>
          </div>
        </div>
      </section>
    </>
  );
};

export default AboutWhy;
